module.exports = __webpack_public_path__ + "static/house-b9a9286a9321fbb007498b5c688b73a1.png";